import React from "react";
import ComplianceDocument from "../components/ui/ComplianceDocument";

export default function PrivacyPage(): React.JSX.Element {
  return (
    <ComplianceDocument
      slug="privacy-policy"
      title="Privacy Policy"
      description={
        <span>
          This Privacy Policy explains how <strong>kivo.skin</strong> (“we”, “us”, “our”) collects, uses, and shares information,
          including photos you upload and results we generate. We aim to be clear and give you control while
          continuing to improve our Service. Nothing here is medical advice.
        </span>
      }
    />
  );
}
